export type LitigationCreationSpace = {
  id: string;
  name: string;
  scope: 'personal' | 'team';
  plans: Array<{id: string; name: string; fileName?: string}>;
};

/**
 * 校验新建台账。表结构由系统方案绑定，不要求用户选择方案。
 * @param spaces 当前用户可写入的空间
 * @param input 名称、范围和保存空间；传入 planId 时仍校验它属于该空间
 */
export function validateLitigationWorkbookCreation(spaces: LitigationCreationSpace[], input: {name: string; scope: string; organizationId: string; planId?: string}) {
  const name = input.name.trim();
  if (!name || name.length > 80) throw new Error('请填写台账名称，最多 80 字');
  if (!['personal', 'team'].includes(input.scope)) throw new Error('请选择个人工作台账或团队工作台账');
  const space = spaces.find((item) => item.id === input.organizationId && item.scope === input.scope);
  if (!space) throw new Error('请选择对应的保存空间');
  const planId = String(input.planId || '').trim();
  if (planId && !space.plans.some((plan) => plan.id === planId)) throw new Error('请选择该空间的台账方案');
  return planId
    ? {name, scope: space.scope, organizationId: space.id, planId}
    : {name, scope: space.scope, organizationId: space.id};
}
